import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hiddenInput", "results"]

  connect() {
    this.selectedSupplierId = null
    this.selectedSupplierName = null
  }

  handleSupplierClick(event) {
    // El evento puede venir del item directamente o necesitamos buscar el más cercano
    const supplierResult = event.currentTarget || event.target.closest('.supplier-assignment-search-result')

    if (supplierResult && supplierResult.dataset.supplierId) {
      event.preventDefault()
      event.stopPropagation()

      const supplierId = supplierResult.dataset.supplierId
      const supplierName = supplierResult.dataset.supplierName

      // Guardar la selección
      this.selectedSupplierId = supplierId
      this.selectedSupplierName = supplierName

      // Actualizar el input con el nombre seleccionado
      if (this.hasInputTarget) {
        this.inputTarget.value = supplierName
      }

      // Actualizar el hidden input
      if (this.hasHiddenInputTarget) {
        this.hiddenInputTarget.value = supplierId
        // Disparar evento change para que el formulario lo detecte
        this.hiddenInputTarget.dispatchEvent(new Event('change', { bubbles: true }))
      }

      // Cerrar el dropdown
      // Buscar el contenedor de resultados (puede estar en supplier-search controller)
      const resultsContainer = this.element.querySelector('[data-supplier-search-target="results"]')
      if (resultsContainer) {
        resultsContainer.classList.add('d-none')
      }
    }
  }
}
